// @flow

const youtubeParser = (url: string | null) => {
  if (!url) return ''
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  var match = url.match(regExp)
  return match && match[7].length == 11 ? match[7] : ''
}

export default youtubeParser